<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left pt-3 pb-12">
                <h1 class="grey--text lighten-3 mb-6"><i class="fas fa-calendar-week"></i> Draw</h1>
                <v-overlay :value="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-overlay>
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete
                            :loading="loading"
                            item-text="season_name"
                            item-value="season_id"
                            v-model.trim="sel_seasons"
                            :items="seasons"
                            label="Seasons"
                            hint="Select a season"
                            persistent-hint
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-autocomplete
                            ref="div_sel"
                            clearable
                            :loading="loading"
                            item-text="division_name"
                            item-value="division_id"
                            v-model.trim="sel_divisions"
                            :items="divisions"
                            label="Divisions"
                            hint="Select a division or type in division name"
                            persistent-hint
                            outlined
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" md="2">
                        <v-select v-model.trim="sel_rounds" :items="rounds" label="Rounds" :disabled="r_disabled" outlined></v-select>
                    </v-col>
                    <v-col cols="6" md="3">
                        <v-autocomplete
                            clearable
                            :loading="loading"
                            item-text="team_name"
                            item-value="team_name"
                            v-model.trim="sel_teams"
                            :items="teams"
                            label="All Teams"
                            hint="Pick your favorite team"
                            persistent-hint
                            outlined
                        ></v-autocomplete>
                    </v-col>
                </v-row>

                <div v-if="draw.divisionDraw">
                    <div
                        v-if="sel_divisions && !loading && (sel_rounds != 'Semi Final' && sel_rounds != 'Final' && sel_rounds != 'Grand Final')"
                        class="text-left red--text subtitle-2 font-italic font-weight-black my-3"
                    >
                        {{ division_note }}
                    </div>
                    <v-row class="ma-0" v-for="(schedule, round) in draw.divisionDraw" :key="round">
                        <div class="col mt-4 round-wrapper pa-0" v-if="sel_rounds == Number(round) + 1 || sel_rounds == 'All Rounds'">
                            <v-col cols="12" v-for="(games, index) in schedule" :key="index">
                                <v-divider class="my-3"></v-divider>
                                <h2>Round #{{ Number(round) + 1 }}</h2>
                                <v-divider class="my-3"></v-divider>
                                <v-flex v-for="(game, indexG) in games" :key="game.game">
                                    <v-card
                                        class="d-flex flex-column pa-3 mb-1 draw-card"
                                        raised
                                        v-if="sel_teams == undefined || (sel_teams != undefined && (game.team_a_id == sel_teams || game.team_b_id == sel_teams || game.duty == sel_teams))"
                                    >
                                        <div class="text-center">
                                            <v-icon color="primary" left>calendar_today</v-icon> {{ game.date_formatted
                                            }}<span v-if="game.double_points != 'No'" class="red--text title font-italic font-weight-black">*</span> {{ byeTeam(game) }}
                                            {{ dutyTeam(game) }}
                                        </div>
                                        <v-divider class="my-3"></v-divider>
                                        <div class="d-flex justify-space-around mb-3 flex-basis-third">
                                            <div class="text-center" v-if="game.excluded_dates">{{ game.match }}</div>
                                            <div class="text-center" v-else>{{ game.team_a_id }}</div>
                                            <div class="text-center font-weight-bold mobile">
                                                {{ game.time_formatted }} <v-icon color="primary" left right class="mx-1">alarm</v-icon> {{ game.courtLabel }}
                                            </div>
                                            <div class="text-center" v-if="game.excluded_dates">{{ game.match }}</div>
                                            <div class="text-center" v-else>{{ game.team_b_id }}</div>
                                        </div>
                                        <div class="text-center mb-2"><v-btn color="secondary" :href="venueLink(game)" target="_blank" class="btnLoc pa-0 mx-1"><v-icon color="primary" left class="mx-0">location_on</v-icon></v-btn> {{ game.venueLabel }}</div>
                                        <v-divider class="my-3"></v-divider>
                                        <div v-if="!game.excluded_dates && !game.scored" class="text-center">
                                            <v-btn color="secondary" :href="genGoogLinkCal(game)" target="_blank" class="btnCal ma-sm-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Google Calendar</v-btn>
                                            <v-btn color="primary" @click="genICal(game)" class="btnCal my-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Apple Calendar</v-btn>
                                        </div>
                                        <div v-else-if="!game.excluded_dates && game.scored && show_results" class="text-center mobile scored font-weight-black">
                                            <v-icon left color="secondary" class="mx-1">sports_basketball</v-icon>{{ game.score_team_a_points }} <span class="full-time">full time</span>
                                            {{ game.score_team_b_points }}<v-icon right color="secondary" class="mx-1">sports_basketball</v-icon>
                                        </div>
                                        <div v-else-if="!game.excluded_dates && game.scored && !show_results" class="text-center subtitle-1 mobile scored red--text">
                                            {{ game.scored }}
                                        </div>
                                    </v-card>
                                    <v-card
                                        class="d-flex flex-column pa-3 mb-3 draw-card bye-duty-team"
                                        raised
                                        v-if="sel_teams != undefined && (game.bye == sel_teams || game.duty == sel_teams)"
                                    >
                                        <div class="text-center">
                                            <v-icon color="primary" left>calendar_today</v-icon> {{ game.date_formatted }} {{ byeTeam(game) }} {{ dutyTeam(game) }}
                                        </div>
                                    </v-card>
                                    <div class="text-left red--text subtitle-2 font-italic font-weight-black mb-2">
                                        <span
                                            v-if="
                                                (sel_teams == undefined || (sel_teams != undefined && (game.team_a_id == sel_teams || game.team_b_id == sel_teams))) &&
                                                    game.double_points != 'No'
                                            "
                                            >* double point round</span
                                        >
                                    </div>
                                </v-flex>
                            </v-col>
                        </div>
                    </v-row>
                </div>
                <div v-if="draw.finalSeries">
                    <div
                        v-if="
                            draw.finalSeries['Semi_Final'] &&
                                draw.finalSeries['Semi_Final'].length &&
                                (sel_rounds == 'Semi Final' || (sel_rounds == 'All Rounds' /*&& sel_teams == undefined*/))
                        "
                    >
                        <v-divider class="my-3 mt-12"></v-divider>
                        <h2>Semi Finals</h2>
                        <v-divider class="my-3"></v-divider>
                        <v-row class="" v-for="(schedule, index) in draw.finalSeries['Semi_Final']" :key="index">
                            <v-col class="py-2" cols="12" v-for="(games, index) in schedule" :key="index">
                                <div v-for="game in games" :key="game.game">
                                    <v-card
                                        class="d-flex flex-column pa-3 draw-card"
                                        raised
                                        v-if="sel_teams == undefined || (sel_teams != undefined && (game.team_a_id == sel_teams || game.team_b_id == sel_teams))"
                                    >
                                        <div class="text-center">
                                            <v-icon color="primary" left>calendar_today</v-icon> {{ game.date_formatted
                                            }}<span v-if="game.double_points != 'No'" class="font-italic font-weight-black">*</span> {{ byeTeam(game) }} {{ dutyTeam(game) }}
                                        </div>
                                        <v-divider class="my-3"></v-divider>
                                        <div class="d-flex justify-space-around mb-3 flex-basis-third">
                                            <div class="text-center">
                                                <span class="" v-if="game.excluded_dates">{{ game.match }}</span>
                                                <span class="" v-else>{{ game.team_a_id }}</span>
                                                <span class="" v-if="game.game_rank_a != game.team_a_id && /*game.ranking && */ game.game_rank_a != ''"><br />{{ game.game_rank_a }}</span>
                                            </div>
                                            <div v-if="game.scored && show_results" class="text-center mobile scored font-weight-black">
                                                <v-icon left color="secondary" class="mx-1">sports_basketball</v-icon>{{ game.score_team_a_points }} <span class="full-time">full time</span> {{ game.score_team_b_points
                                                }}<v-icon right color="secondary" class="mx-1">sports_basketball</v-icon>
                                            </div>
                                            <div v-else-if="game.scored && !show_results" class="text-center subtitle-1 mobile scored red--text">
                                            {{ game.scored }}
                                            </div>
                                            <div v-else class="text-center mobile font-weight-bold">
                                                {{ game.time_formatted }} <v-icon color="primary" left right class="mx-1">alarm</v-icon> {{ game.courtLabel }}
                                            </div>
                                            <div class="text-center">
                                                <span class="" v-if="game.excluded_dates">{{ game.match }}</span>
                                                <span class="" v-else>{{ game.team_b_id }}</span>
                                                <span class="" v-if="game.game_rank_b != game.team_b_id && /*game.ranking && */ game.game_rank_b != ''"><br />{{ game.game_rank_b }}</span>
                                            </div>
                                        </div>
                                        <div v-if="!game.scored" class="text-center"><v-icon color="primary" left class="mx-1">location_on</v-icon> {{ game.venueLabel }}</div>
                                        <v-divider class="my-3"></v-divider>
                                        <div v-if="!game.excluded_dates && !game.scored" class="text-center">
                                            <v-btn color="secondary" :href="genGoogLinkCal(game)" target="_blank" class="btnCal ma-sm-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Google Calendar</v-btn>
                                            <v-btn color="primary" @click="genICal(game)" class="btnCal my-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Apple Calendar</v-btn>
                                        </div>
                                    </v-card>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <div v-if="draw.finalSeries['Final'] && draw.finalSeries['Final'].length && (sel_rounds == 'Final' || (sel_rounds == 'All Rounds' /*&& sel_teams == undefined*/))">
                        <v-divider class="my-3 mt-12"></v-divider>
                        <h2>Finals</h2>
                        <v-divider class="my-3"></v-divider>
                        <v-row class="" v-for="(schedule, index) in draw.finalSeries['Final']" :key="index">
                            <v-col class="py-2" cols="12" v-for="(games, index) in schedule" :key="index">
                                <div v-for="game in games" :key="game.game">
                                    <v-card
                                        class="d-flex flex-column pa-3 draw-card"
                                        raised
                                        v-if="sel_teams == undefined || (sel_teams != undefined && (game.team_a_id == sel_teams || game.team_b_id == sel_teams))"
                                    >
                                        <div class="text-center">
                                            <v-icon color="primary" left>calendar_today</v-icon> {{ game.date_formatted
                                            }}<span v-if="game.double_points != 'No'" class="font-italic font-weight-black">*</span> {{ byeTeam(game) }} {{ dutyTeam(game) }}
                                        </div>
                                        <v-divider class="my-3"></v-divider>
                                        <div class="d-flex justify-space-around mb-3 flex-basis-third">
                                            <div class="text-center">
                                                <span class="" v-if="game.excluded_dates">{{ game.match }}</span>
                                                <span class="" v-else>{{ game.team_a_id }}</span>
                                                <span class="" v-if="game.game_rank_a != game.team_a_id && /*game.ranking && */ game.game_rank_a != ''"><br />{{ game.game_rank_a }}</span>
                                            </div>
                                            <div v-if="game.scored && show_results" class="text-center mobile scored font-weight-black">
                                                <v-icon left color="secondary" class="mx-1">sports_basketball</v-icon>{{ game.score_team_a_points }} <span class="full-time">full time</span> {{ game.score_team_b_points
                                                }}<v-icon right color="secondary" class="mx-1">sports_basketball</v-icon>
                                            </div>
                                            <div v-else-if="game.scored && !show_results" class="text-center subtitle-1 mobile scored red--text">
                                            {{ game.scored }}
                                            </div>
                                            <div v-else class="text-center mobile font-weight-bold">
                                                {{ game.time_formatted }} <v-icon color="primary" class="mx-1">alarm</v-icon> {{ game.courtLabel }}
                                            </div>
                                            <div class="text-center">
                                                <span class="" v-if="game.excluded_dates">{{ game.match }}</span>
                                                <span class="" v-else>{{ game.team_b_id }}</span>
                                                <span class="" v-if="game.game_rank_b != game.team_b_id && /*game.ranking && */ game.game_rank_b != ''"><br />{{ game.game_rank_b }}</span>
                                            </div>
                                        </div>
                                        <div v-if="!game.scored" class="text-center"><v-icon color="primary" left class="mx-1">location_on</v-icon> {{ game.venueLabel }}</div>
                                        <v-divider class="my-3"></v-divider>
                                        <div v-if="!game.excluded_dates && !game.scored" class="text-center">
                                            <v-btn color="secondary" :href="genGoogLinkCal(game)" target="_blank" class="btnCal ma-sm-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Google Calendar</v-btn>
                                            <v-btn color="primary" @click="genICal(game)" class="btnCal my-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Apple Calendar</v-btn>
                                        </div>
                                    </v-card>
                                </div>
                            </v-col>
                        </v-row>
                    </div>

                    <div
                        v-if="
                            draw.finalSeries['Grand_Final'] &&
                                draw.finalSeries['Grand_Final'].length &&
                                (sel_rounds == 'Grand Final' || (sel_rounds == 'All Rounds' /*&& sel_teams == undefined*/))
                        "
                    >
                        <v-divider class="my-3 mt-12"></v-divider>
                        <h2>Grand Finals</h2>
                        <v-divider class="my-3"></v-divider>
                        <v-row class="" v-for="(schedule, index) in draw.finalSeries['Grand_Final']" :key="index">
                            <v-col class="py-2" cols="12" v-for="(games, index) in schedule" :key="index">
                                <div v-for="game in games" :key="game.game">
                                    <v-card
                                        class="d-flex flex-column pa-3 draw-card"
                                        raised
                                        v-if="sel_teams == undefined || (sel_teams != undefined && (game.team_a_id == sel_teams || game.team_b_id == sel_teams))"
                                    >
                                        <div class="text-center">
                                            <v-icon color="primary" left>calendar_today</v-icon> {{ game.date_formatted
                                            }}<span v-if="game.double_points != 'No'" class="font-italic font-weight-black">*</span> {{ byeTeam(game) }} {{ dutyTeam(game) }}
                                        </div>
                                        <v-divider class="my-3"></v-divider>
                                        <div class="d-flex justify-space-around mb-3 flex-basis-third">
                                            <div class="text-center">
                                                <span class="" v-if="game.excluded_dates">{{ game.match }}</span>
                                                <span class="" v-else>{{ game.team_a_id }}</span>
                                                <span class="" v-if="game.game_rank_a != game.team_a_id && /*game.ranking && */ game.game_rank_a != ''"><br />{{ game.game_rank_a }}</span>
                                            </div>
                                            <div v-if="game.scored && show_results" class="text-center mobile scored font-weight-black">
                                                <v-icon left color="secondary" class="mx-1">sports_basketball</v-icon>{{ game.score_team_a_points }} <span class="full-time">full time</span> {{ game.score_team_b_points
                                                }}<v-icon right color="secondary" class="mx-1">sports_basketball</v-icon>
                                            </div>
                                            <div v-else-if="game.scored && !show_results" class="text-center subtitle-1 mobile scored red--text">
                                            {{ game.scored }}
                                            </div>
                                            <div v-else class="text-center mobile font-weight-bold">
                                                {{ game.time_formatted }} <v-icon color="primary" left right class="mx-1">alarm</v-icon> {{ game.courtLabel }}
                                            </div>
                                            <div class="text-center">
                                                <span class="" v-if="game.excluded_dates">{{ game.match }}</span>
                                                <span class="" v-else>{{ game.team_b_id }}</span>
                                                <span class="" v-if="game.game_rank_b != game.team_b_id && /*game.ranking && */ game.game_rank_b != ''"><br />{{ game.game_rank_b }}</span>
                                            </div>
                                        </div>
                                        <div v-if="!game.scored" class="text-center"><v-icon color="primary" left class="mx-1">location_on</v-icon> {{ game.venueLabel }}</div>
                                        <v-divider class="my-3"></v-divider>
                                        <div v-if="!game.excluded_dates && !game.scored" class="text-center">
                                            <v-btn color="secondary" :href="genGoogLinkCal(game)" target="_blank" class="btnCal ma-sm-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Google Calendar</v-btn>
                                            <v-btn color="primary" @click="genICal(game)" class="btnCal my-2"><i class="fas fa-calendar-plus pr-2"></i>Add to Apple Calendar</v-btn>
                                        </div>
                                    </v-card>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "@modules/draw/_store";
import { downloadIcs, formatLocation, googleCalendarUrl } from "@shared/calendar";

export default {
    name: "draw",
    data() {
        return {
            sel_seasons: null,
            sel_divisions: null,
            sel_teams: undefined,
            sel_rounds: null,
            rounds: [],
            r_disabled: false,
            division_note: "",
            use_params: false,
            show_results: true,
        };
    },
    watch: {
        sel_seasons: function(val, oldVal) {
            this.$store
                .dispatch("draw/getDivisions", { seasonId: val })
                .then(resp => {
                    this.sel_rounds = null;
                    this.rounds = [];
                    this.sel_teams = undefined;
                    this.division_note = "";
                    this.show_results = true;
                    this.$refs.div_sel.lazySearch = "";

                    if(!val) {
                        this.use_params = false;
                        this.sel_divisions = null;
                    }

                    if(this.use_params && this.sel_seasons && this.$route.params.division_id != undefined){
                        this.sel_divisions = parseInt(this.$route.params.division_id);
                    }
                })
                .catch(err => {
                    // console.log(err);
                });
        },
        sel_divisions: function(val, oldVal) {
            let note = '';
            let show_results = true;

            if(val){
                note = this.divisions.find(division => division.division_id === val).division_note;
                show_results = this.divisions.find(division => division.division_id === val).division_show_score_result;
            }

            this.division_note = "";
            if (note) {
                this.division_note = "Note: " + note;
            }

            this.show_results = show_results;

            if(val){
                this.$store.dispatch("draw/getTeams", { divisionId: val });

                this.$store
                    .dispatch("draw/getDraw", { divisionId: val })
                    .then(resp => {
                        // if(resp.data.divisionDraw.length){
                        // this.rounds = [...Array.from(Array(resp.data.divisionDraw.length), (e, i) => Number(i) + 1)];
                        this.rounds = [...Array(_.size(resp.data.divisionDraw)).keys()].map(x => ++x);
                        this.rounds.unshift("All Rounds");
                        this.sel_rounds = "All Rounds";
                        this.sel_teams = undefined;
                        this.r_disabled = false;

                        if(!val) {
                            this.use_params = false;
                            this.sel_teams = null;
                        }

                        if(this.use_params && this.sel_divisions && this.$route.params.team_name != undefined){
                            this.sel_teams = this.$route.params.team_name;
                        }

                        if (!_.isEmpty(resp.data.finalSeries["Semi_Final"])) {
                            this.rounds.push("Semi Final");
                        }
                        if (!_.isEmpty(resp.data.finalSeries["Final"])) {
                            this.rounds.push("Final");
                        }
                        if (!_.isEmpty(resp.data.finalSeries["Grand_Final"])) {
                            this.rounds.push("Grand Final");
                        }
                        // }
                    })
                    .catch(err => {
                        // console.log(err);
                    });
            }
        },
        sel_teams: function(val, oldVal) {
            if (_.isUndefined(val) || _.isNull(val)) {
                this.sel_rounds = "All Rounds";
                this.r_disabled = false;
            } else {
                this.r_disabled = true;
                this.sel_rounds = "All Rounds";
            }

            if(!val) {
                this.use_params = false;
            }
        },
    },
    computed: {
        loading() {
            return this.$store.getters["draw/drawStatus"] == "loading";
        },
        seasons() {
            return this.$store.getters["draw/seasons"];
        },
        divisions() {
            return this.$store.getters["draw/divisions"];
        },
        teams() {
            return this.$store.getters["draw/teams"];
        },
        draw() {
            return this.$store.getters["draw/draw"];
        },
    },
    methods: {
        byeTeam(game) {
            if (game.bye == "None") {
                return "";
            }

            return "  -- Bye Team: " + game.bye;
        },
        dutyTeam(game) {
            if (game.duty == "None") {
                return "";
            }

            return "  -- Duty Team: " + game.duty;
        },
        venueLink(game){
            return encodeURI("https://www.google.com/maps/search/" + (game.venueLabel ? game.venueLabel : "") + " " + (game.venueAddress ? game.venueAddress : "") + " " + (game.venueSuburb ? game.venueSuburb : "") + " " + (game.venuePostcode ? game.venuePostcode : "") + " " + (game.venueState ? game.venueState : ""));
        },
        calendarEvent(game) {
            let dutyStr = "";
            if (game.duty != "None") {
                dutyStr = "  -- Duty Team: " + game.duty;
            }

            return {
                uid: game.game,
                title: this.appNameUrls.client + " - Games",
                start: game.date_time_from,
                end: game.date_time_to,
                location: formatLocation({
                    name: game.venueLabel,
                    address: game.venueAddress,
                    suburb: game.venueSuburb,
                    state: game.venueState,
                    postcode: game.venuePostcode,
                }),
                descriptionLines: [
                    game.match_formatted,
                    game.courtLabel + " @ " + game.time_formatted + " on " + game.date_formatted + dutyStr,
                ],
                timezone: this.lmpTz,
                filename: "games.ics",
            };
        },
        genGoogLinkCal(game) {
            return googleCalendarUrl(this.calendarEvent(game));
        },
        genICal(game) {
            downloadIcs(this.calendarEvent(game));
        },
    },
    beforeCreate() {
        // if(_.isEmpty(this.$store.getters['draw/seasons'])){
        this.$store.dispatch("draw/getSeasons");
        // }
    },
    mounted() {
        if(this.$route.params.season_id != undefined){
            this.sel_seasons = parseInt(this.$route.params.season_id);
            this.use_params = true;
        }
    },
};
</script>

<style lang="scss">
.draw-card {
    &:hover {
        background-color: var(--drawer-color) !important;
        border-color: var(--drawer-color) !important;
        color: #fff !important;
        caret-color: #fff !important;
    }
}
.btnLoc {
        min-width: 34px !important;
        height: 22px !important;
        vertical-align: sub;
    }
.flex-basis-third {
    div {
        flex: 1 1 33.33%;
    }
}
.full-time {
    padding: 4px 8px;
    text-transform: uppercase;
    color: #ffffff;
    background-color: red;
    border-radius: 4px;
    margin: 0 4px;
}
.round-wrapper {
    .col.col-12 .flex:nth-of-type(n + 2) .bye-duty-team {
        display: none !important;
    }
}
@media screen and (max-width: 767px) {
    .v-autocomplete__content.v-menu__content {
        z-index: 999999 !important;
    }

    .flex-basis-third .mobile.scored {
        flex: 1 1 75%;
    }

    .btnCal {
        min-width: 100% !important;
    }
}
</style>
